<dashboard-dialog-frame icon='fa-solid fa-info-circle' header="Survey Comments" [actions]='actions'
	[dialogRef]='dialogRef'>
	<div class="d-flex flex-column gap-2 p-2">
		<div>{{label}}</div>

		@if(!comments.length){
		<div class="color-gray text-center"><i>No Comments</i></div>
		}
		@else {
		<table class='pro-table'>
			<tr>
				<th>Entrepreneur</th>
				<th>Comment</th>
			</tr>

			@for(comment of comments; track $index; ){
			<tr>
				<td> {{comment.name}}</td>
				<td> {{comment.comment}}</td>
			</tr>
			}
		</table>
		}
	</div>
</dashboard-dialog-frame>